export const SITE = {
  upiId: "99bazaar@upi",
  whatsapp: "919999999999",
  whatsappLabel: "+91 99999 99999",
  contactEmail: "contact@99bazaarmaharashtra.com",
  address: "99Bazaar Maharashtra, Pune, Maharashtra - 411001",
};

export const siteUrl = () => window.location.origin;
